import { key } from 'core-ts-types';
import * as _4 from 'lodash4';

interface IFeedbackTermsState {
  opened: boolean;
  termId: number;
}

interface ICourseGroupState {
  opened: boolean;
}
export interface IAPComponentStateModel {
  studentFeedbackTerms: IFeedbackTermsState[];
  courseGroups: ICourseGroupState[];
  wildcards: ICourseGroupState[];
}

export class APComponentStateModel {
  studentFeedbackTerms: IFeedbackTermsState[] = [];
  courseGroups: ICourseGroupState[] = [];
  wildcards: Record<string, ICourseGroupState> = {};

  clear() {
    this.studentFeedbackTerms = [];
    this.courseGroups = [];
    this.wildcards = {};
    return this;
  }

  courseGroupClose(id: key) {
    this.courseGroups[id] = { opened: false };
  }

  wildcardToggle(id: key, state: boolean) {
    this.wildcards[id] = { opened: state };
  }

  courseGroupToggle(id: key, state: boolean) {
    this.courseGroups[id] = { opened: state };
  }
}

angular.module('capability-ng-academic-planner').service('ngAPComponentStateModel', APComponentStateModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/models/ap_component_state_model.ts